export default __webpack_public_path__ + "static/luke-chesser-JKUTrJ4vK00-unsplash-b5aaad43ac9e04bba4d56b4951f352b0.jpg";